<div class="user-group">
  <div class="header mt-2 pb-10">
    <div class="d-flex justify-content-between">
      <span  (click)="navigateBack()">
        <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        
      />

      </span>

      <div class="text-center">
        <h4 class="mb-4">
          <span> {{ formGroupUserDetail?.value?.firstName }} </span>

          <span> {{ formGroupUserDetail?.value?.lastName }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">{{ 'USER_ADD_USER' | translate }}</h1>
      </div>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="d-flex pt-3">
      <h2 class="heading1 m-auto">
        {{ 'USER_TYPE' | translate }}
      </h2>
    </div>
    <p class="m-auto text-center px-60 pt-3">
      {{ 'USER_GROUP_GRANT_ACCESS_TITLE' | translate }}
    </p>
  </div>
  <form
    [formGroup]="formGroup"
    tabindex="0"
    (keyup.enter)="validatedUserType()"
    #userType
    novalidate
  >
    <div class="group-container">
      <ng-container *ngFor="let radionButton of radionButtons; let i = index">
        <div
          (click)="radionButton.disabled ? null : activate(radionButton)"
          class="checked-card mr-2"
          [class.active]="radionButton.active"
          [class.disabled]="radionButton.disabled"
          [class.not-allowed]="radionButton.disabled"
        >
          <img
            [src]="
              radionButton.active
                ? 'assets/svg/ico-check-circle.svg'
                : 'assets/svg/ico-circle-check.svg'
            "
            class="check-circle"
          />
          <div class="content-box">
            <input
              type="radio"
              class="d-none"
              name="userType"
              [value]="radionButton.value"
              formControlName="userType"
            />
            <h3 class="title">{{ radionButton.label }}</h3>
            <p class="detail">
              {{ radionButton.desc }}
            </p>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="row">
      <div class="col-12 my-1 mt-3">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="
            formGroup?.invalid ||
            this.formInstance?.userType.value ===
              userTypeRequest[CONSTANTS.RESIDENT]
          "
          type="button"
          (click)="submit()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
